/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamGridExamid200,
  GetApiV1ExamGridExamid400,
  GetApiV1ExamGridExamid401,
  GetApiV1ExamGridExamid500,
  GetApiV1ExamGridExamidPathParams,
  GetApiV1ExamGridExamidQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamGridExamid.ts";
import { examGridListItemViewModelSchema } from "../examGridListItemViewModelSchema.ts";

export const getApiV1ExamGridExamidPathParamsSchema = z.object({
  examId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamGridExamidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamGridExamid200Schema = z.lazy(
  () => examGridListItemViewModelSchema,
) as unknown as ToZod<GetApiV1ExamGridExamid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamGridExamid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGridExamid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamGridExamid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGridExamid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamGridExamid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGridExamid500>;

export const getApiV1ExamGridExamidQueryResponseSchema = z.lazy(
  () => getApiV1ExamGridExamid200Schema,
) as unknown as ToZod<GetApiV1ExamGridExamidQueryResponse>;
